import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {CheckIcon, XCloseIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {TKey, useTranslation} from '@/translations/i18n'

export const PatientDetailsConsent = ({value, label}: {value: boolean; label: TKey}) => {
    const {t} = useTranslation()

    return (
        <Text size="textSm" palette="neutral" shade="500">
            <Flexbox gap={1} align="center" render="span">
                {value ? <CheckIcon size={15} /> : <XCloseIcon size={15} />}
                {t(label)}
            </Flexbox>
        </Text>
    )
}
